import request from "./request";
import URLS from "../configurations/urls";
import Api from "./Api";

class ScriptsApi extends Api {
  static getScripts(params) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_SCRIPTS}`;
    options.params = params;
    return request.get(options);
  }

  static getScript(scriptId) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_SCRIPTS}/${scriptId}`;
    options.params = {};
    return request.get(options);
  }

  static updateScript(scriptId, params) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.ARBITER_API_SCRIPTS}/${scriptId}`;
    options.data = params;
    return request.patch(options);
  }
}
export default ScriptsApi;



// WEBPACK FOOTER //
// ./src/api/ScriptsApi.js